var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.bookingDateIsToday &&
    _vm.bookingAppearanceInPerson &&
    !_vm.bookingInPersonCompleted &&
    !_vm.talentCompletedInPerson &&
    _vm.talentCanMarkAsCompleteInPerson
      ? _c("div", { staticClass: "alert-large alert-large-info" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "alert-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _vm.bookingDateIsTodayExactly
                  ? _c("p", { staticClass: "no-margin" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$userIsTalent
                              ? "Today is the day! Once the booking is finished mark it as complete to receive your commission."
                              : `Today is the day! Once ${_vm.user.name}'s booking is finished mark it and they'll receive their commission.`
                          ) +
                          "\n            "
                      ),
                    ])
                  : _c("p", { staticClass: "no-margin" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$userIsTalent
                              ? "Your booking has happened! Once the booking is finished mark it as complete to receive your commission."
                              : `${_vm.user.name}'s booking has happened! Once the booking is finished mark it as complete and they'll receive their commission.`
                          ) +
                          "\n            "
                      ),
                    ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-success btn-job-complete",
                    on: {
                      click: function ($event) {
                        return _vm.handleMarkBookingCompleteCallback(
                          "in_person"
                        )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Mark As Complete\n            "),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.bookingAppearanceOnline &&
    !_vm.bookingOnlineCompleted &&
    !_vm.talentCompletedOnline &&
    _vm.talentCanMarkAsCompleteOnline
      ? _c("div", { staticClass: "alert-large alert-large-info" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "alert-content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c("p", { staticClass: "no-margin" }, [
                  _vm._v(
                    "\n              " +
                      _vm._s(
                        _vm.$userIsTalent
                          ? "Finished your online commitment? Mark it as complete to receive your commission."
                          : `${_vm.user.name} finished their online commitment? Mark it as complete and they'll receive their commission.`
                      ) +
                      "\n            "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-success btn-job-complete",
                    on: {
                      click: function ($event) {
                        return _vm.handleMarkBookingCompleteCallback("online")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Mark As Complete\n            "),
                  ]
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-calendar" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-container" }, [
      _c("i", { staticClass: "fa fa-map-marker" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }